import apiClient from "@utils/axios.utils";

export interface Survey {
    id: number;
    title: string;
    description: string;
    isActive: boolean;
    url: string;
    clickAmount: number;
    createdAt: string;
    updatedAt: string;
}

// Récupérer la liste des enquêtes actives
export const getActiveSurveys = async (): Promise<Survey[]> => {
    try {
        const response = await apiClient.get<Survey[]>("/surveys/active");
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des enquêtes actives :", error);
        throw error;
    }
};

// Récupérer une enquête par son id
export const getSurveyById = async (id: number): Promise<Survey> => {
    try {
        const response = await apiClient.get<Survey>(`/surveys/public/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération de l'enquête ${id} :`, error);
        throw error;
    }
};

export const addSurveyClick = async (id: number): Promise<void> => {
    try {
        await apiClient.post(`/surveys/${id}/click`);
    } catch (error) {
        console.error(`Erreur lors de l'ajout du clic pour l'enquête ${id} :`, error);
        throw error;
    }
};